import React from 'react';
import SectionHeader from './SectionHeader';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const steps = [
  {
    id: '01',
    title: "Define System",
    desc: "Clarify constraints, success metrics, and architectural requirements.",
    icon: FiIcons.FiTarget
  },
  {
    id: '02',
    title: "Prototype Intelligence",
    desc: "Rapid model validation and UX shell development.",
    icon: FiIcons.FiZap
  },
  {
    id: '03',
    title: "Integrate & Harden",
    desc: "Connect to real data streams and handle edge cases robustly.",
    icon: FiIcons.FiLayers
  },
  {
    id: '04',
    title: "Deploy & Iterate",
    desc: "Monitor performance, gather feedback, and refine the model.",
    icon: FiIcons.FiRefreshCw
  }
];

const Process = () => {
  return (
    <section id="process" className="py-24 bg-charcoal relative border-t border-white/5">
      <div className="container mx-auto px-6">
        <SectionHeader title="Engineering Process" subtitle="From abstract concept to deployed reality." />

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-12">
          {steps.map((step, index) => (
            <motion.div
              key={step.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              className="relative p-6 border border-white/5 bg-obsidian group hover:border-neon-cyan/30 transition-colors"
            >
              {/* Connector Line (Desktop) */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-6 w-8 h-[1px] bg-white/10 z-10"></div>
              )}

              <div className="text-5xl font-orbitron font-black text-white/5 absolute top-2 right-4 group-hover:text-neon-cyan/10 transition-colors">
                {step.id}
              </div>
              
              <div className="mb-6 text-neon-cyan">
                <SafeIcon icon={step.icon} className="text-3xl" />
              </div>

              <h3 className="text-lg font-bold font-orbitron text-white mb-3">{step.title}</h3>
              <p className="text-sm text-gray-400 leading-relaxed font-mono">
                {step.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;